import React from 'react';
import { Title1, Body1, Badge, makeStyles, tokens } from '@fluentui/react-components';
import { NavLink, Outlet, Navigate } from 'react-router';
import { useMsal } from '@azure/msal-react';
import { useSwaAuth } from '../../hooks/useSwaAuth';
import { useEnvironment } from '../../contexts/AppContext';

const useStyles = makeStyles({
  container: {
    maxWidth: '1200px', margin: '0 auto', padding: tokens.spacingVerticalL, overflowX: 'hidden',
    '@media (max-width: 768px)': { paddingTop: tokens.spacingVerticalS, paddingLeft: 0, paddingRight: 0 },
  },
  header: { marginBottom: tokens.spacingVerticalL, display: 'flex', alignItems: 'baseline', gap: tokens.spacingHorizontalS },
  subnav: {
    display: 'flex',
    gap: tokens.spacingHorizontalS,
    borderBottom: `1px solid ${tokens.colorNeutralStroke3}`,
    paddingBottom: tokens.spacingVerticalS,
    marginBottom: tokens.spacingVerticalL,
    flexWrap: 'wrap',
    '@media (max-width: 768px)': {
      gap: '2px',
    },
  },
  loadingContainer: { padding: tokens.spacingVerticalL },
});

export default function AdminLayout() {
  const styles = useStyles();
  const { currentEnvironment, isDev } = useEnvironment();
  const { isAdmin, loading } = useSwaAuth();

  const linkStyle = ({ isActive }: { isActive: boolean }) => ({
    padding: `${tokens.spacingVerticalSNudge} ${tokens.spacingHorizontalMNudge}`,
    borderRadius: tokens.borderRadiusMedium,
    textDecoration: 'none',
    color: isActive ? tokens.colorNeutralBackground1 : 'inherit',
    background: isActive ? tokens.colorBrandForeground1 : 'transparent',
    fontWeight: isActive ? 600 : 500,
  });

  if (loading) {
    return <div className={styles.loadingContainer}>Loading…</div>;
  }

  if (!isAdmin) {
    return <Navigate to="/myaccess" replace />;
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Title1>Admin</Title1>
      </div>

      <nav className={styles.subnav}>
        <NavLink to="/admin" end style={linkStyle}>
          Dashboard
        </NavLink>
        <NavLink to="/admin/apis" style={linkStyle}>
          APIs
        </NavLink>
        <NavLink to="/admin/backends" style={linkStyle}>
          Backends
        </NavLink>
        <NavLink to="/admin/pools" style={linkStyle}>
          Resource Pools
        </NavLink>
        <NavLink to="/admin/drift" style={linkStyle}>
          Config Drift
        </NavLink>
        <NavLink to="/admin/model-approvals" style={linkStyle}>
          Model Approvals
        </NavLink>
        <NavLink to="/admin/tasks" style={linkStyle}>
          Tasks
        </NavLink>
      </nav>

      <Outlet />
    </div>
  );
}
